var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{ref:"toolbarDomRef",staticClass:"toolbar"}),_c('div',{ref:"editorDomRef",staticClass:"guides-editor"})])}
var staticRenderFns = []

export { render, staticRenderFns }